function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#pure_to_pure);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pure_to_pure",
  x1: 94.89,
  y1: 250,
  x2: 408,
  y2: 250,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1fc3f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4cbfac"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M417.11,59.26H336.29l-1.57-1.72a114.39,114.39,0,0,0-169.46,0l-1.58,1.72H82.86A42.63,42.63,0,0,0,52.32,72a44.23,44.23,0,0,0-12.69,31.34L59.58,436.45A43.37,43.37,0,0,0,102.83,480H397.15a43.27,43.27,0,0,0,30.58-12.59,41.64,41.64,0,0,0,12.64-29.78l20-335.44A43.25,43.25,0,0,0,417.11,59.26ZM154.78,119.48a96.47,96.47,0,0,1,190.42,0l1,6.18-6.26,0c-23-.13-41.73-.23-58.79-.28h-4.47l-.73-4.41a26.28,26.28,0,0,0-26-22.06c-.18,0-.36,0-.54,0l-3-5L235.06,75a9.1,9.1,0,1,0-15.6,9.36l10.11,16.85,2.87,4.62A26.3,26.3,0,0,0,224,120.92l-.73,4.41h-4.47c-17,0-35.75.15-58.78.28l-6.26,0ZM421.84,436.93a24.72,24.72,0,0,1-24.69,24.53H102.83c-13.83,0-24.69-11.23-24.72-25.56L58.17,102.82a24.78,24.78,0,0,1,24.69-25h67.2l-3.65,7.59A113.61,113.61,0,0,0,135,135a9.18,9.18,0,0,0,2.74,6.57,8.51,8.51,0,0,0,6.54,2.7c92.87-.58,118.55-.58,211.38,0A9.29,9.29,0,0,0,365,135a113.68,113.68,0,0,0-11.42-49.6l-3.65-7.59h67.19c13.37,0,24.69,10.91,24.72,23.82Z"
});

var SvgIconWeight = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWeight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_weight.d3a6d5a0.svg";
export { ForwardRef as ReactComponent };